<template>
  <div class="blue-grey lighten-1 white--text subheading">
    <v-avatar class="mt-1" color="indigo darken-1" size="32">
      <span class="white--text headline">{{ avatar }}</span>
    </v-avatar>
    <div class="title">{{ title }}</div>
  </div>
</template>

<script>
export default {
  props: ['avatar', 'title']
}
</script>

<style scoped lang="scss">
.subheading {
  align-items: center;
  display: flex;
  flex-direction: row;
  padding: 10px 20px;
  width: 100%;
}
.v-avatar {
  min-width: 32px !important;
}
.title {
  flex-grow: 1;
  line-height: 1.3em !important;
  padding-left: 15px;
}
</style>
